import * as React from 'react';
import styled from 'styled-components';
import SingleNameForm from './SingleNameForm';
import PhoneNumberInputForm from './PhoneNumberInputForm';
import EmailInputForm from './EmailInputForm';

const AboutYouFormContainer = styled.div`
  background: #ffffff;
  border: 1px solid #bdbdbd;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
`;

interface props {
  onChange?: ((firstName: string, lastName: string, phoneNumber: string, email: string) => void);
}

interface state {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
}

class AboutYouForm extends React.Component<props, state> {
  state = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
  };
  render() {
    return (
      <AboutYouFormContainer>
        <SingleNameForm
          onChange={(firstName, lastName) =>
            this.props.onChange &&
            this.setState(
              { firstName, lastName },
              () =>
                this.props.onChange &&
                this.props.onChange(
                  this.state.firstName,
                  this.state.lastName,
                  this.state.phoneNumber,
                  this.state.email,
                ),
            )
          }
        />
        <PhoneNumberInputForm
          onChange={phoneNumber =>
            this.setState(
              { phoneNumber },
              () =>
                this.props.onChange &&
                this.props.onChange(
                  this.state.firstName,
                  this.state.lastName,
                  this.state.phoneNumber,
                  this.state.email,
                ),
            )
          }
        />
        <EmailInputForm
          onChange={email =>
            this.setState(
              { email },
              () =>
                this.props.onChange &&
                this.props.onChange(
                  this.state.firstName,
                  this.state.lastName,
                  this.state.phoneNumber,
                  this.state.email,
                ),
            )
          }
        />
      </AboutYouFormContainer>
    );
  }
}

export default AboutYouForm;



// WEBPACK FOOTER //
// ./src/components/FormComponents/AboutYouForm.tsx